import { Box } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'

export const MenuBox = withStyles((theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    paddingTop: `${theme.constants.brandBanner.mobileHeight + theme.constants.toolbar.mobileHeight}px`,
    width: '100vw',
  },
}))(Box)

export const StyledPaper = withStyles(() => ({
  root: {
    fontSize: '1.125rem',
    lineHeight: 1.4,
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100vh',
  },
}))(Paper)

export const InnerContentBox = withStyles((theme) => ({
  root: {
    paddingTop: `${theme.constants.toolbar.mobileHeight}px`,
    textAlign: 'center',
  },
}))(Box)
